import React from 'react';
import { TableCell, Typography } from '@material-ui/core';
import { format } from 'date-fns';
import { convertTokens } from '@date-fns/upgrade/v2';

import { GivingAccountWithdrawalStatus, ProviderType } from 'generated/graphql';
import { red } from 'utils/color-styles';
import { CurrencyCode, currencyFormat } from 'utils/currencyFormat';

import { TransactionTypeLabels } from '../constants';
import { getTransactionDateForTransaction } from '../summarizeTransactions';
import { Transaction } from '../types';

import { BatchFileDownloadButton } from './BatchFileDownloadButton';
import { BatchFileStatusButton } from './BatchFileStatusButton';
import { TransactionTableRow } from './TransactionTableRow';

export const GivingAccountWithdrawalTransactionRow = ({
  transaction,
  accountCurrency,
  accountProvider,
}: {
  transaction: Extract<Transaction, { __typename: 'GivingAccountWithdrawal' }>;
  accountCurrency: CurrencyCode;
  accountProvider: ProviderType;
}) => {
  const rate = transaction.totalAccountCurrency
    ? transaction.totalAccountCurrency / transaction.total
    : null;

  return (
    <TransactionTableRow
      collapsibleContent={
        <>
          {accountCurrency !== transaction.currencyCode && rate && (
            <>
              <Typography variant="body2" style={{ fontWeight: 500 }}>
                Exchange rate
              </Typography>
              <br />
              <Typography variant="body2">
                {currencyFormat(transaction.amount, transaction.currencyCode as CurrencyCode)} ={' '}
                {typeof transaction.totalAccountCurrency === 'number' &&
                typeof transaction.feeAmountAccountCurrency === 'number'
                  ? currencyFormat(
                      transaction.totalAccountCurrency - transaction.feeAmountAccountCurrency,
                      accountCurrency
                    )
                  : '-'}
              </Typography>
              <br />
              <Typography variant="body2">
                {currencyFormat(1, transaction.currencyCode as CurrencyCode)} ={' '}
                {currencyFormat(rate, accountCurrency)}
              </Typography>
              <br />
            </>
          )}
          <Typography variant="body2" style={{ fontWeight: 500 }}>
            Fee amount
          </Typography>
          <br />
          <Typography variant="body2">
            {currencyFormat(transaction.feeAmountAccountCurrency || 0, accountCurrency)}{' '}
            {accountCurrency !== transaction.currencyCode && (
              <>
                (
                {currencyFormat(
                  transaction.feeAmount || 0,
                  transaction.currencyCode as CurrencyCode
                )}
                )
              </>
            )}
          </Typography>
        </>
      }
    >
      <TableCell style={{ paddingLeft: 0 }}>
        <Typography variant="body2">
          {format(
            new Date(getTransactionDateForTransaction(transaction)),
            convertTokens('MMM DD, YYYY')
          )}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">{TransactionTypeLabels[transaction.__typename]}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">{transaction.description ?? transaction.identifier}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">{transaction.provider}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2" style={{ color: red }}>
          -
          {typeof transaction.totalAccountCurrency === 'number'
            ? currencyFormat(transaction.totalAccountCurrency, accountCurrency)
            : '-'}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">
          {typeof transaction.balance === 'number' &&
          transaction.status === GivingAccountWithdrawalStatus.Processed
            ? currencyFormat(transaction.balance, accountCurrency)
            : '-'}
        </Typography>
      </TableCell>
      <TableCell>
        <BatchFileDownloadButton givingAccountWithdrawal={transaction} />
      </TableCell>
      <TableCell>
        {transaction.status !== 'Processed' ? (
          <BatchFileStatusButton
            givingAccountWithdrawal={transaction}
            accountCurrency={accountCurrency}
            accountProvider={accountProvider}
          />
        ) : null}
      </TableCell>
    </TransactionTableRow>
  );
};
